module.exports = __webpack_public_path__ + "p5_img2.jpg?3a0ccc70c18cca7fc97593baed48fded";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p5/p5_img2.jpg
// module id = 124
// module chunks = 0